export default {
  ESTIMATE: "estimate",
  LIST: "list",
}